import React, { useContext, useState } from "react";
import { Modal, Button, Text } from "@mantine/core";
import { FoldersContext } from "../contexts/FoldersContext";

const DeleteFolderModal = ({ opened, onClose, folder }) => {
  const { deleteFolder } = useContext(FoldersContext);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    await deleteFolder(folder.value);
    setLoading(false);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Delete Folder"
      centered
      keepMounted={false}
      styles={{ title: { fontWeight: 600 } }}
    >
      <Text size="sm">
        Are you sure you want to delete the folder "{folder?.label}"? This
        action cannot be undone.
      </Text>
      <Button
        mt="md"
        fullWidth
        color="red"
        onClick={handleDelete}
        loading={loading}
      >
        Delete
      </Button>
    </Modal>
  );
};

export default DeleteFolderModal;
